/**
 * Perfil (GEN-PX-006). Solo lectura.
 *  - Propio (sin `empleado`): nombre, email, rol y avatar con iniciales. Rol y email se gestionan en
 *    Administración, y aquí se dice. El email sale de lib/perfil.js (ID token; el descriptor no lo lleva).
 *  - De otro empleado (`empleado` = la fila de GET /v1/entrada/empleados que ya tiene la entrada):
 *    nombre, cargo (si existe) y rol. Sin email: el kernel no se lo da al resto de usuarios.
 * Lo que el usuario podrá cambiar (foto, idioma, avisos) se decide más adelante: hoy no hay nada editable.
 */

import { useSession } from '../context/SessionContext.jsx'
import { Avatar, Tarjeta } from './ui.jsx'
import { inicialesDe, rolTexto } from '../lib/empleados.js'
import { emailPropio } from '../lib/perfil.js'

function Dato({ etiqueta, children }) {
  return (
    <div className="dk-perfil__dato">
      <dt>{etiqueta}</dt>
      <dd>{children}</dd>
    </div>
  )
}

export default function Perfil({ empleado = null }) {
  const { user, token } = useSession()
  const propio = !empleado
  const nombre = (propio ? user?.display_name : empleado.nombre) ?? ''
  const rol = rolTexto(propio ? user?.rol : empleado.rol)
  const cargo = propio ? '' : (empleado.cargo ?? '').trim()
  const email = propio ? emailPropio(user, token) : null

  return (
    <div className="dk-perfil">
      <div className="dk-perfil__area">
        <Tarjeta className="dk-perfil__tarjeta">
          <header className="dk-perfil__cab">
            <Avatar iniciales={inicialesDe(nombre)} nombre="" tamano={72} />
            <div>
              <h1 className="dk-perfil__nombre">{nombre}</h1>
              <span className="dk-meta">{propio ? 'Tu perfil' : 'Perfil de un empleado'}</span>
            </div>
          </header>
          <dl className="dk-perfil__datos">
            <Dato etiqueta="Nombre">{nombre}</Dato>
            {propio && <Dato etiqueta="Email">{email ?? '—'}</Dato>}
            {cargo && <Dato etiqueta="Cargo">{cargo}</Dato>}
            <Dato etiqueta="Rol">{rol}</Dato>
          </dl>
          {propio && <p className="dk-perfil__nota dk-meta">Tu rol y tu email se gestionan en Administración.</p>}
        </Tarjeta>
      </div>
    </div>
  )
}
